import DigitalCards from '@/components/DigitalCards/DigitalCards.jsx';
import React, { useContext, useEffect, useState } from 'react';
import { LoyaltyCard, RedemptionSummaryCard, TitleAndBack } from '@desquared/wave-components-library';
import LoyaltyCardFront from '../../../public/assets/wave-grocery/LoyaltyCardFront.png';
import { ResponsiveMenuStore } from '@/store/sideSheet';
import { useTranslations } from 'next-intl';
import styles from './Loyalty.module.css';
import { CurrencyContext } from '@/contexts/CurrencyProvider';
import Cookies from 'universal-cookie';
import { getUserV3TransactionsSummary } from '@/api/wave/users';
import LoaderStore from '@/store/loader';

const cookies = new Cookies();
const token = cookies.get('token');

export default function Loyalty({ user, card, showLoyaltyCardButton }) {
  const t = useTranslations('user_loyalty');

  const [userData, setUserData] = useState(null);
  const openMenu = () => {
    ResponsiveMenuStore.open();
  };
  const { formatter } = useContext(CurrencyContext);

  useEffect(() => {
    LoaderStore.addEvent('LOAD_USER_LOYALTY_SUMMARY');

    getUserV3TransactionsSummary(token)
      .then(data => {
        setUserData(data);
      })
      .catch(error => {
        console.error('Error fetching user summary:', error);
      })
      .finally(() => {
        LoaderStore.removeEvent('LOAD_USER_LOYALTY_SUMMARY');
      });
  }, [user]);
  return (
    <div className={styles.loyaltyContainer}>
      <TitleAndBack wording={t('loyalty')} onBack={() => openMenu()} />
      <div className={styles.loyaltyCardsContainer}>
        <LoyaltyCard
          CardCodeWording={t('card_code')}
          CardCode={user.loyaltyCards[0]?.cardId}
          Points={user.totalLoyaltyPoints}
          PointsTotalWording={t('points_total')}
          ClickWording={t('click')}
          onCopy={() => {
            navigator.clipboard.writeText(user.loyaltyCards[0]?.cardId);
          }}
          FrontOfCard={card ?? LoyaltyCardFront.src}
          snackBarWording={t('snack_bar')}
        />
        <div className={styles.redemptionSummaryCardContainer}>
          <RedemptionSummaryCard
            pointsValue={user?.totalLoyaltyPoints}
            postfix={t('redemptionCardSummary.postfix')}
            // orders={userData?.totalTransactions}
            // redeemedPoints={userData?.totalRedeemedPoints}
            savings={user?.totalLoyaltyBalance / 100}
            currencyFormatter={formatter}
            currentBalanceLabel={t('currentBalanceLabel')}
            // totalOrdersLabel={t('totalOrdersLabel')}
            // totalRedeemedPointsLabel={t('totalRedeemedPointsLabel')}
            totalSavingsLabel={t('totalSavingsLabel')}
          />
        </div>
      </div>
      <DigitalCards card={card} user={user} showLoyaltyCardButton={showLoyaltyCardButton} />
    </div>
  );
}
